import { useState } from "react";
import AsyncSelect from "react-select/async";
import { getAllMembers } from "app/services/distributorService";

const MemberAutoComplete = ({
  setState,
  name,
  selectedValue,
  setSelectedValue,
}) => {
  const [inputValue, setInputValue] = useState("");
  //   const [selectedValue, setSelectedValue] = useState(null);
  // Handle input change
  const handleInputChange = (value) => {
    setInputValue(value);
  };

  // Handle option selection
  const handleChange = (selectedOption) => {
    setSelectedValue(selectedOption);
    setState(selectedOption?.id || "");
  };

  // Load options from API
  const loadOptions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await getAllMembers(inputValue);

    return (
      data?.data
        ?.filter((item) => item.memberType.toLowerCase() == "merchant") // Filter only merchants
        .map((item) => ({
          id: item.memId,
          label: `${item.company} - ${item.uniqueIdentity} - ${item.memberMobileNo}`,
          balance: `${item.balance}`,
        })) || []
    );
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name={name}
    />
  );
};

export default MemberAutoComplete;
